export interface LambdaCorrelationScope {
  userId?: string | undefined;
  organizationId?: string | undefined;
  roomId?: string | undefined;
  studioId?: string | undefined;
}

// Registry reads must share the request-header scope without importing the
// PostHog manager, whose analytics/UI dependencies lead back into the registry.
let scope: LambdaCorrelationScope = {};
let fallbackOrganizationId: string | undefined;
const listeners = new Set<() => void>();
const notify = (): void => {
  for (const listener of listeners) listener();
};

export const lambdaCorrelationScope = {
  get: (): Readonly<LambdaCorrelationScope> => scope,
  getCacheScope: (): string =>
    JSON.stringify([
      scope.userId ?? '',
      scope.organizationId ?? fallbackOrganizationId ?? '',
      scope.studioId ?? '',
      scope.roomId ?? ''
    ]),
  getOrganizationId: (): string => scope.organizationId ?? fallbackOrganizationId ?? '',
  set: (next: LambdaCorrelationScope): void => {
    scope = { ...scope, ...next };
    notify();
  },
  // Preserve the manager's analytics-group fallback before a studio pins scope.
  setFallbackOrganizationId: (organizationId: string): void => {
    fallbackOrganizationId = organizationId;
    notify();
  },
  reset: (): void => {
    scope = {};
    fallbackOrganizationId = undefined;
    notify();
  },
  subscribe: (listener: () => void): (() => void) => {
    listeners.add(listener);
    return () => {
      listeners.delete(listener);
    };
  }
};
